import { render, staticRenderFns } from "./1ActivitateHranitoare.vue?vue&type=template&id=2673f30a"
import script from "./1ActivitateHranitoare.vue?vue&type=script&lang=js"
export * from "./1ActivitateHranitoare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports